<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { usePwaInstall } from '@/composables/usePwaInstall'
import Button from '@/components/ui/Button.vue'

const { t } = useI18n()
const { showInstall, showIosHint, platform, install, dismiss } = usePwaInstall()

const installBodyKey = computed(() =>
  platform.value === 'windows' || platform.value === 'macos'
    ? 'pwa.installBodyDesktop'
    : 'pwa.installBody',
)
</script>

<template>
  <div
    v-if="showInstall || showIosHint"
    class="fixed inset-x-0 bottom-0 z-40 p-4 pb-[max(1rem,env(safe-area-inset-bottom))]"
    role="dialog"
    :aria-label="showInstall ? t('pwa.installTitle') : t('pwa.iosHintTitle')"
  >
    <div class="card-panel mx-auto flex max-w-lg flex-col gap-3">
      <div>
        <p class="text-sm font-semibold text-body">
          {{ showInstall ? t('pwa.installTitle') : t('pwa.iosHintTitle') }}
        </p>
        <p class="mt-1 text-sm text-muted">
          {{ showInstall ? t(installBodyKey) : t('pwa.iosHintBody') }}
        </p>
      </div>
      <div class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <Button
          variant="ghost"
          class="w-full sm:w-auto"
          @click="dismiss"
        >
          {{ t('pwa.dismiss') }}
        </Button>
        <Button
          v-if="showInstall"
          class="w-full sm:w-auto"
          @click="install"
        >
          {{ t('pwa.installAction') }}
        </Button>
      </div>
    </div>
  </div>
</template>
